"use strict";
/**
 * This component is the mask for currently selected product on the Konva canvas
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_konva_1 = require("react-konva");
var use_image_1 = __importDefault(require("use-image"));
function MatboardImage(_a, ref) {
    var _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, width = _a.width, height = _a.height, imageUrl = _a.imageUrl, _d = _a.rotation, rotation = _d === void 0 ? 0 : _d, _e = _a.visible, visible = _e === void 0 ? true : _e, onImageLoad = _a.onImageLoad, onLoad = _a.onLoad;
    var imageRef = React.useRef(null);
    var image = use_image_1.default(imageUrl, "anonymous")[0];
    // When the image loads, pass the size upwards to the Image Editor
    React.useEffect(function () {
        // onLoad(true)
        if (onImageLoad && image) {
            onImageLoad({ width: image.width, height: image.height });
            // onLoad(false)
        }
    }, [image]);
    return (React.createElement(react_konva_1.Image, { visible: visible, rotation: rotation, offset: { x: width / 2, y: height / 2 }, 
        // globalCompositeOperation='destination-in'
        ref: ref, x: x, y: y, width: width, height: height, image: image }));
}
exports.default = React.forwardRef(MatboardImage);
